import type { Task, TaskFolder } from 'owa-todo-service';

/**
 * See https://alexanderplatz.visualstudio.com/To-Do/_git/to-do-api-documentation?path=%2FToDoClients.md&version=GBmaster&_a=preview for task notificaiton API documentation
 */

export enum ToDoNotificationType {
    Setting = 'Setting',
    Task = 'Task',
    TaskFolder = 'TaskFolder',
}
export enum ToDoNotificationOperationType {
    Created = 'Created',
    Updated = 'Updated',
    Deleted = 'Deleted',
}

export type ToDoNotification =
    | SettingToDoNotification
    | TaskToDoNotification
    | TaskFolderToDoNotification;

interface NotificationBase {
    /**
     * The type of the entity, e.g.: Setting, Task, TaskFolder or KeepAlive
     *
     * @type {ToDoNotificationType}
     */
    Type: ToDoNotificationType;

    /**
     * The type of change that occurred, e.g.: Created, Updated or Deleted.
     *
     * @type {ToDoNotificationOperationType}
     */
    Operation: ToDoNotificationOperationType;

    /**
     *  The id of the entity that was affected.
     *
     * @type {string}
     */
    Id: string;
}

export interface SettingToDoNotification extends NotificationBase {
    Type: ToDoNotificationType.Setting;

    /**
     * The payload of the event after the event was applied.
     *
     * @type {any}
     */
    Payload?: any;
}

export interface TaskToDoNotification extends NotificationBase {
    Type: ToDoNotificationType.Task;

    /**
     * The payload of the event after the event was applied. In case of Delete this hash is empty.
     *
     * @type {string}
     */
    Payload?: Task;
}

export interface TaskFolderToDoNotification extends NotificationBase {
    Type: ToDoNotificationType.TaskFolder;

    /**
     * The payload of the event after the event was applied. In case of Delete this hash is empty.
     *
     * @type {string}
     */
    Payload?: TaskFolder;
}
